import { Dialog, styled } from '@mui/material';
import { PinnacleDialogProps } from './PinnacleDialog.types';

const StyledPinnacleDialog = styled(Dialog)<PinnacleDialogProps>(
  ({ theme }) => ({
    '& .MuiPaper-root': {
      margin: '32px 16px',
      borderRadius: '8px',
      backgroundColor: 'transparent',
      boxShadow: '0px 4px 16px 8px rgba(143, 143, 143, 0.1)'
    },
    '& .MuiDialogContent-root': {
      padding: '20px',
      scrollbarColor: '#003367 #00080F',
      scrollbarWidth: 'thin',

      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#003367',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#00080F',
      },
    },
    '& .MuiAutocomplete-popper .MuiPaper-root': {
      margin: 0,
      borderRadius: 0,
      padding: 0,
    },
    '& .btnCloseModal svg': {
      color: theme.palette.secondary.main,
    },
    '& .headerTitle': {
      textAlign: 'left',
      textTransform: 'lowercase',

      ':first-letter': {
        textTransform: 'capitalize',
      },
    },
  }),
);

export default StyledPinnacleDialog;
